// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./styled/font/Lato-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./styled/font/Lato-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./styled/font/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./styled/font/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Roboto";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400 !important;
  background-color: #f0f2f5;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

html {
  box-sizing: border-box;
  -ms-overflow-style: scrollbar;
  font-size: 1rem !important;
}

@font-face {
  font-family: "Lato-Thin";
  src: local("Lato-Thin"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "Lato-Light";
  src: local("Lato-Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "Lato-Regular";
  src: local("Lato-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

@font-face {
  font-family: "Lato-Bold";
  src: local("Lato-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

.customOverlay {
  background: rgba(0, 0, 0, 0.7);
}

.smallModal {
  min-width: 35rem;
  max-width: 35rem !important;
  border-radius: 0.875rem;
  padding: 0 !important;
  overflow-y: visible !important;
}

.addPost {
  min-width: 40rem;
  max-width: 40rem !important;
  border-radius: 1.875rem;
  padding: 0 !important;
}

@media screen and (min-width: 620px) and (max-width: 9999px) {
  .addPost {
    min-width: 35rem;
    max-width: 35rem !important;
  }
}

@media screen and (min-width: 520px) and (max-width: 620px) {
  .addPost {
    min-width: 30rem;
    max-width: 30rem !important;
  }
}

@media screen and (min-width: 480px) and (max-width: 520px) {
  .addPost {
    min-width: 25rem !important;
    max-width: 25rem !important;
  }
}

@media only screen and (max-width: 480px) {
  .addPost {
    min-width: 10.125rem !important;
    max-width: 25rem !important;
  }
}

.imageCropModal {
  min-width: 50rem !important;
  min-height: 30rem !important;
  border-radius: 0.875rem !important;
  padding: 0 !important;
}

.addPostModal {
  min-width: 40rem;
  max-width: 40rem !important;
  overflow-y: visible !important;
  border-radius: 0.875rem !important;
  padding: 0 !important;
}

@media screen and (min-width: 620px) and (max-width: 9999px) {
}

@media screen and (min-width: 520px) and (max-width: 620px) {
  .addPostModal {
    min-width: 30rem;
    max-width: 30rem !important;
  }
}

@media screen and (min-width: 480px) and (max-width: 520px) {
  .addPostModal {
    min-width: 25rem !important;
    max-width: 25rem !important;
  }
}

@media only screen and (max-width: 480px) {
  .addPostModal {
    min-width: 10.125rem !important;
    max-width: 25rem !important;
  }
}

.successModal {
  min-width: 35rem;
  border-radius: 1.875rem;
}

.locationModal {
  border-radius: 1.875rem;
  padding: 0 !important;
}

.slider-control-bottomcenter > ul {
  top: 1rem !important;
}

.paging-item > button {
  padding: 0.2rem;
}

.paging-item.active > button {
  fill: green !important;
}

@media screen and (min-width: 620px) and (max-width: 9999px) {
  .locationModal {
    min-width: 35rem;
    max-width: 35rem !important;
  }
}

@media screen and (min-width: 520px) and (max-width: 620px) {
  .locationModal,
  .smallModal {
    min-width: 30rem;
    max-width: 30rem !important;
  }
}

@media screen and (min-width: 0px) and (max-width: 419px) {
  .locationModal {
    min-width: 20rem;
    max-width: 20rem !important;
  }
}

@media screen and (min-width: 0px) and (max-width: 520px) {
  .smallModal {
    min-width: 20rem;
    max-width: 20rem !important;
  }
}

.downLoadReportModal {
  min-width: 32rem;
  max-width: 32rem !important;
  border-radius: 6px;
  padding: 0 !important;
}

.filterModal {
  min-width: 28rem;
  max-width: 28rem !important;
  border-radius: 6px;
  padding: 0 !important;
}

.toast-container {
  z-index: 9999999 !important;
}

.reviewRequest {
  min-width: 32rem;
  max-width: 32rem !important;
  border-radius: 6px;
  padding: 0 !important;
}

.addReviewModal {
  min-width: 27rem;
  max-width: 27rem !important;
  border-radius: 6px;
  padding: 0 !important;
}

.createNewApiModal {
  min-width: 30rem;
  max-width: 30rem !important;
  border-radius: 6px;
  padding: 0 !important;
}

.editModal {
  min-width: 28rem;
  max-width: 30rem !important;
  border-radius: 6px;
  padding: 0 !important;
}

.addNewModal {
  min-width: 28rem;
  max-width: 28rem !important;
  border-radius: 6px;
  padding: 0 !important;
}

.bulkCardModal {
  border-radius: 6px;
  padding: 0 !important;
}

.compaignModal {
  max-width: 1200px !important;
}

p {
  margin-bottom: 0;
  margin: 0 0 0px;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  /* font-family: 'Playfair Display', serif; */
}

#carousel div div.carousel .thumbs-wrapper {
  margin: 0rem !important;
}

#carousel div.carousel-root div.carousel.carousel-slider .control-dots {
  margin-bottom: 4.5rem;
}

@media screen and (min-width: 0px) and (max-width: 767px) {
  #carousel div.carousel-root div.carousel.carousel-slider .control-dots {
    margin-bottom: 1rem;
  }
}

#pre,
#next {
  display: none;
}

#testimonials div.carousel-root div.carousel.carousel-slider .control-dots {
  display: none;
}

#testimonialsPre,
#testimonialsNext {
  display: none;
}

.phoneInputFields {
  font-family: "Roboto";
  width: 100% !important;
  line-height: 2rem !important;
  outline: none;
  font-weight: 400;
  text-align: left;
  font-size: 0.875rem !important;
  border-radius: 0.375rem !important;
  padding: 0.5rem 0.8rem !important;
  padding-left: 60px !important;
  border: 1px solid #e1e1e1 !important;
  color: #333333;
  background: #ffffff;
  height: auto !important;
}

.react-tel-input .flag-dropdown {
  top: 0.063rem !important;
  bottom: 0.063rem !important;
  left: 0.063rem !important;
  width: 3rem !important;
  background: #ffffff00 !important;
  border-bottom-left-radius: 0.375rem !important;
  border-top-left-radius: 0.375rem !important;
  border-top: none !important;
  border-bottom: none !important;
  border-left: none !important;
  border-right: 1px solid #e1e1e1 !important;
  padding-left: 0.2rem !important;
}

.phoneInputFields:focus {
  border: 1px solid #1fc3e0 !important;
  box-shadow: none !important;
}

.phoneInputFields:focus + .flag-dropdown {
  border-right: 1px solid #1fc3e0 !important;
  box-shadow: none !important;
}

.react-tel-input .form-control,
.react-tel-input .selected-flag:hover,
.react-tel-input .selected-flag:focus,
.react-tel-input .flag-dropdown.open .selected-flag {
  background: #ffffff00 !important;
}

/* ......... Data Table Css ......... */
table {
  border-collapse: separate !important;
  border-spacing: 0 5px !important;
}

.mdb-dataTable-head tr th {
  font-family: "Roboto";
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 5px;
  text-transform: capitalize;
  color: #000000;
  opacity: 0.4;
  padding-bottom: 1.2rem !important;
  line-height: 1;
}

.mdb-dataTable tbody tr td {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400 !important;
  font-size: 14px;
  line-height: 32px;
  text-transform: capitalize;
  color: #666666;
}

tr th:last-child {
  text-align: end;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffffff8c !important;
  border-radius: 4px;
}

.table-striped tbody tr:nth-of-type(even) {
  background-color: white;
  border-radius: 4px;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  color: #666666 !important;
}

.mdb-datatable table tr {
  border-bottom: 0 !important;
}

tr td:first-child {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

tr td:last-child {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  text-align: end;
}

.table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: none !important;
}

.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: none !important;
  padding: 1rem 0.75rem 1.1rem 0.75rem !important;
}

a:hover,
a:focus {
  text-decoration: none !important;
}

.form-control {
  box-shadow: none !important;
  /* padding: 0.5rem 0.8rem !important; */
}

/* ---------- ImageCarousel  ------- */
.image-gallery-thumbnails-container {
  text-align: start !important;
  padding: 0.15rem 0.5rem !important;
}

.image-gallery-thumbnails-container button {
  border: none !important;
  margin-right: 0.43rem;
}

.image-gallery-thumbnails-container button > span > img {
  border-radius: 4px !important;
  opacity: 0.5;
  object-fit: cover;
}

.image-gallery-thumbnails-container button > span > img {
  border-radius: 4px !important;
  opacity: 0.5;
  height: 5.7rem;
}

.image-gallery-thumbnails-container
  button.image-gallery-thumbnail.active
  > span
  > img {
  border-radius: 4px !important;
  opacity: 1 !important;
}

.image-gallery-image {
  object-fit: cover !important;
}

@media screen and (min-width: 992px) and (max-width: 9999px) {
  .image-gallery-image {
    height: 24.5rem;
  }
}

@media screen and (min-width: 0px) and (max-width: 992px) {
  .image-gallery-image {
    max-height: -moz-fit-content !important;
    max-height: fit-content !important;
  }

  .image-gallery-thumbnails-container button > span > img {
    height: 4.7rem;
  }
}

/* ---------- ImageCarousel End  ------- */

/* ----------  AdminGraph ----------  */
.recharts-text {
  font-family: "Roboto";
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  padding: 0.5rem;
}

/* ----------  AdminGraph End ----------  */

/* --------SummerNote Fixing---------- */
.btn-default,
.btn-default.dropdown-toggle {
  color: #333 !important;
  background-color: #fff !important;
  border-color: #ccc !important;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 5px 10px !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
  border-radius: 3px !important;
}

.btn {
  margin: 0 !important;
  text-transform: capitalize !important;
}

.btn:hover,
.btn:focus,
.btn:active {
  outline: 0 !important;
  box-shadow: none !important;
}

.btn-group,
.btn-group-vertical {
  box-shadow: none !important;
}

.btn-group > .btn:first-child {
  margin-left: 0 !important;
}

.btn-default.dropdown-toggle:hover,
.btn-default.dropdown-toggle:focus {
  color: #333 !important;
  background-color: #e6e6e6 !important;
  border-color: #adadad !important;
}

.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.btn-group > .btn-group:not(:last-child) > .btn,
.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0 !important;
}

.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group {
  margin-left: -1px !important;
}

.dropdown-toggle::after {
  display: none !important;
}

.note-popover .popover-content .note-color .dropdown-toggle,
.note-editor .note-toolbar .note-color .dropdown-toggle {
  padding-left: 5px !important;
}

.btn-default:active:hover,
.btn-default.active:hover,
.open > .dropdown-toggle.btn-default:hover,
.btn-default:active:focus,
.btn-default.active:focus,
.open > .dropdown-toggle.btn-default:focus,
.btn-default:active.focus,
.btn-default.active.focus,
.open > .dropdown-toggle.btn-default.focus {
  color: #333 !important;
  background-color: #d4d4d4 !important;
  border-color: #8c8c8c !important;
}

.btn-default:not([disabled]):not(.disabled):active,
.btn-default:not([disabled]):not(.disabled).active,
.show > .btn-default.dropdown-toggle {
  background-color: #d4d4d4 !important;
  box-shadow: none;
}

.btn:active,
.btn.active {
  background-image: none;
  outline: 0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%) !important;
}

.btn-default:active,
.btn-default.active,
.open > .dropdown-toggle.btn-default {
  color: #333 !important;
  background-color: #e6e6e6 !important;
  background-image: none;
  border-color: #adadad !important;
}

.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group {
  margin-left: -1px !important;
}

.btn-default:hover {
  color: #333 !important;
  background-color: #e6e6e6 !important;
  border-color: #adadad !important;
}

/* --------SummerNote Fixing End---------- */

/* --------SummerNote Model Fixing---------- */
button.close {
  padding: 0 !important;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}

.modal-header {
  display: block !important;
}

.modal-header .close {
  margin: auto !important;
}

.note-group-select-from-files input {
  font: -webkit-control !important;
}

.btn-primary {
  color: #fff;
  background-color: #337ab7 !important;
  border-color: #2e6da4 !important;
}

.btn[disabled] {
  cursor: not-allowed !important;
}

.note-editable {
  background-color: transparent !important;
}

/* --------SummerNote Model Fixing End---------- */

/* --------Input Tags---------- */

.rti--container {
  background: transparent !important;
  border: 1px solid #e1e1e1 !important;
  border-radius: 0.375rem !important;
  line-height: 2rem !important;
  padding: 0.5rem 0.8rem !important;
  font-size: 0.875rem !important;
}

.rti--container > input {
  padding: 0 !important;
}

.rti--container:focus-within {
  border-color: #1fc3e0 !important;
  box-shadow: none !important;
}

.rti--tag {
  background: #56ccf2 !important;
  border-radius: 6px !important;
  padding: 0 0.2rem 0 0.7rem !important;
  color: #ffffff !important;
  font-family: "Roboto" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  justify-content: space-between !important;
  text-transform: capitalize !important;
}

.rti--tag > span {
  padding-right: 0.5rem !important;
}

.rti--tag > button {
  font-size: 0.7rem !important;
  font-weight: 700 !important;
}

/* --------Input Tags End---------- */

/* --------- POST CARUSEL ----------- */
.owl-nav {
  /* display: flex;
	align-items: center; */
  /* display: none; */
}

.owl-prev {
  /* display: none !important; */
  position: absolute !important;
  left: 0rem !important;
  top: 40% !important;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5) !important;
  position: absolute !important;
  background: white !important;
  width: 2rem !important;
  border-radius: 100% !important;
  height: 2rem !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.owl-prev:hover {
  /* background: transparent !important; */
  background: rgb(56, 176, 0) !important;
}

.owl-next:hover {
  /* background: transparent !important; */

  background: rgb(56, 176, 0) !important;
}

.owl-next {
  /* display: none !important; */
  /* box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5) !important; */
  position: absolute !important;
  right: 0rem !important;
  top: 40% !important;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5) !important;
  position: absolute !important;
  background: white !important;
  width: 2rem !important;
  border-radius: 100% !important;
  height: 2rem !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.owl-next span {
  color: black !important;
  font-size: 26px;
  display: block;
  top: -5px;
  position: absolute;
}

.owl-prev span {
  color: black !important;
  font-size: 26px;
  display: block;
  top: -5px;
  position: absolute;
}

.owl-next:hover span,
.owl-prev:hover span {
  color: #ffffff !important;
}

.swal2-icon.swal2-success .swal2-success-ring {
  border: 0.25em solid #ffffff !important;
}

.swal2-icon.swal2-success [class^="swal2-success-line"],
.swal2-icon.swal2-success [class^="swal2-success-line"] {
  background-color: #ffffff !important;
}

.swal2-popup {
  background: #0e7b2f !important;
  color: #ffffff !important;
}

.swal2-icon.swal2-success [class^="swal2-success-circular-line"][class\$="left"],
.swal2-icon.swal2-success .swal2-success-fix,
.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right {
  background-color: rgb(62 21 21 / 0%) !important;
}

.swal2-styled.swal2-confirm {
  background-color: #ffffff !important;
  color: #0e7b2f !important;
  padding: 0.5rem 2rem !important;
  border: none !important;
  outline: none !important;
}

/* REACT DATEPICKER/ */

.react-calendar__navigation__label {
  color: #40730a !important;
  /* font-weight: 700 !important; */
  /* font-size: 1.5rem; */
}

.react-calendar__month-view__weekdays__weekday {
  text-decoration: underline !important;
}

.react-calendar__tile--active {
  background-color: #32cd32 !important;
}

.react-calendar__navigation > button {
  color: #32cd32 !important;
}

.react-calendar__tile:enabled:hover {
  background-color: #ff7d09 !important;
}

.react-calendar__navigation button:enabled:hover {
  background-color: #ff7d09 !important;
  color: white !important;
}

.react-calendar__tile--now {
  background-color: #32cd32 !important;
}

.react-datetime-picker__wrapper {
  border: none !important;
  display: flex !important;
}

.character {
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  border: none;
  font-size: 20px;
  border-radius: 8px;

  /* light theme */
  color: #272729;
  background-color: #f6f5fa;
  box-shadow: 0 2px 0 #e4e2f5;
}

.upload {
  margin: 0;
}

.rmsc {
  --rmsc-main: #4285f4 !important;
  --rmsc-hover: #3f730a !important;
  --rmsc-selected: #e2e6ea;
  --rmsc-border: #ccc;
  --rmsc-gray: #aaa;
  --rmsc-bg: #fff;
  /* color: #fff; */
  --rmsc-p: 10px;
  /* Spacing */
  --rmsc-radius: 4px;
  /* Radius */
  --rmsc-h: 38px;
  /* Height */
}

/* .e-multiselect.e-input-group .e-input-group-icon,
.e-multiselect.e-input-group.e-control-wrapper .e-input-group-icon:hover {
	color: red !important;
	font-size: 14px;
}

.e-popup .e-checkbox-wrapper .e-frame.e-check,
.e-popup .e-checkbox-wrapper:hover .e-frame.e-check {
	background-color: green !important;
	color: white;
} */

ol,
ul {
  padding-left: 0rem;
}

.rmsc .select input:focus {
}

.dropdown-container {
  /* background: red !important; */
  border: 1px solid #efeff0 !important;
}

.select-item {
  margin: 0px !important;
  /* color: white !important; */
}

.select-item:hover {
  margin: 0px !important;
  color: white !important;
}

.paging-item {
  display: none !important;
}

/* //Spinner 1  */

.spinner-container {
  position: relative;
  width: 100px;
  height: 100px;
}

.spinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 5px solid #0fcba1;
  border-top-color: #fff;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotateX(35deg) rotateY(45deg) rotateZ(0deg);
  }

  100% {
    transform: rotateX(35deg) rotateY(45deg) rotateZ(360deg);
  }
}

/* Chrome, Safari, Edge, Opera */
#quantity input::-webkit-outer-spin-button,
#quantity input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
#quantity input[type="number"] {
  -moz-appearance: textfield;
  /* text-align: center; */
}

.dropdown-content {
  z-index: 2 !important;
}

.react-input-emoji--container {
  background-color: #ffffff !important;
  border: 1px solid #ffffff !important;
  border-radius: 30px !important;
}

.react-input-emoji--input {
  min-height: 40px !important;
  height: auto;
  padding: 10px 165px 10px 20px !important;
  background-color: #f0f2f5;
  border-radius: 1.5rem;
  vertical-align: middle;
  word-break: break-all;
}

.react-input-emoji--button svg {
  fill: #6c757d !important;
  width: 20px;
  height: 20px;
}

.react-input-emoji--button__show svg {
  fill: #32cd32 !important;
}

.react-input-emoji--button {
  position: absolute !important;
  right: 5.2rem;
  z-index: 2;
}

@media screen and (min-width: 0px) and (max-width: 768px) {
  .react-input-emoji--input {
    padding: 12px 126px 12px 12px !important;
    font-size: 12px !important;
  }

  .react-input-emoji--button {
    /* bottom: -2.2rem; */
    padding: 0px !important;
  }
}

.react-emoji-picker--wrapper {
  z-index: 1 !important;
}

.react-input-emoji--container {
  margin: 0 !important;
}

#customCalendar .react-datetime-picker__inputGroup {
  display: none !important;
}
.react-datetime-picker__inputGroup {
  margin-right: 10px !important;
}

.react-datetime-picker__inputGroup__leadingZero {
  display: none !important;
}

.react-datetime-picker__calendar {
  z-index: 2 !important;
}

/* .wy-avatar-presence img {
  object-fit: cover;
} */

/* .wy-avatar-presence.wy-avatar {
	height: rem;
	width: 6rem;
} */

/* .wy-appbars {
  z-index: 0 !important;
  box-shadow: none !important;
  border-bottom: 1px solid rgb(221 221 234);
  background-color: #ffffff !important;
  backdrop-filter: none;
  padding: 8px;
  border-radius: 12px 12px 0px 0px;
  position: static !important;
} */

/* .wy-appbar {
  z-index: 0 !important;
  font-weight: 600;
} */

/* .wy-messages {
   max-height: 33rem;  
  max-height: calc(100vh - 270px);
  overflow: hidden;
  overflow-y: scroll;
  height: 100vh;
} */

.wy-messages {
  border: 2px solid red !important;
  /* overflow: scroll; */
  /* min-height: calc(100vh - 220px); */
  /* max-height: calc(100vh - 220px); */
}

/* .wy-conversations {
  max-height: 80vh;
  position: relative;
  overflow-y: auto;
  width: 25rem;
  padding: 0.875rem;
} */

/* @media screen and (min-width: 0px) and (max-width: 767px) {
  .wy-conversations {
    max-height: 33rem;
    position: relative;
    overflow-y: scroll;
    width: 100%;
  }
} */

.wy-meta {
  font-size: 12px !important;
}

.wy-item-text {
  font-size: 14px !important;
}

.wy-item-hover {
  border-radius: 12px;
}

.wy-item-hover:hover {
  background-color: #eef2f6;
  border-radius: 12px;
}

.react-datetime-picker__button {
  padding: 0rem !important;
}

.react-datetime-picker__inputGroup__input {
  padding: 0px 1px !important;
  height: auto !important;
  width: 60px !important;
  text-align: center !important;
}

.hide-month-icon .react-date-picker__button__icon {
  display: none;
}

.connectModel {
  /* width: 100%; */
  padding: 50px !important;
  border-radius: 0.875rem;
  background: #fff;
}

.productDetailModel {
  padding: 50px !important;
  border-radius: 0.875rem;
  background: #fff;
  width: 100%;
}

.commentModel {
  border-radius: 0.875rem;
  background: #fff;
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 840px) {
  .productDetailModel {
    width: 90%;
  }

  .commentModel {
    width: 90%;
    padding: 0 !important;
  }
}

.react-datetime-picker__inputGroup__input--hasLeadingZero {
  margin-left: -0.014em !important;
}

.reactEasyCrop_CropArea.reactEasyCrop_CropAreaGrid {
  width: 450px !important;
  height: 250px !important;
}

/* .owl-item {
	margin-right: 0px !important;
} */

.owl-item img {
  border-radius: 0.5rem !important;
}

#postsCarosel .owl-item {
  display: flex;
  justify-content: center;
}

#postsCarosel .owl-carousel .owl-stage {
  display: flex;
  align-items: center;
}

#postsCarosel .owl-carousel .owl-item img {
  width: auto;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 16/9;
  border-radius: 0rem !important;
}

#postsCarosel .owl-carousel .owl-item {
  margin-right: 0px !important;
}

.swal2-popup {
  background-color: rgb(223, 222, 222) !important;
}

.my-custom-swal .swal2-close {
  color: black;
}

#postsCarosel .owl-carousel .owl-item img {
  width: 100% !important;
}

.owl-theme .owl-nav {
  margin-top: 0px;
}

.hover-link {
  border-bottom: 2px solid transparent;
}

.hover-link:hover {
  /* border-bottom: 2px solid rgb(56, 176, 0); */
  border-color: rgb(56, 176, 0);
}

.width-100 {
  width: 33.33%;
  background-color: #0e7b2f;
}

.post-actions-lcs a {
  border-radius: 6px;
  padding: 8px !important;
}

.post-actions-lcs a:hover {
  background-color: #f2f2f2;
}

.most-viewed-posts {
  padding: 0px;
  border-radius: 48px;
  margin-bottom: 8px;
}

.most-viewed-posts:hover {
  background-color: #e7e7e8;
}

.dots-hover {
  padding: 8px;
}

.dots-hover:hover {
  background-color: #f0f2f5;
  border-radius: 50%;
}

.w-14px {
  width: 14px !important;
}

/* .most-viewed {
	background-color: #F7F9F9 !important;
	border-radius: 12px;
} */

.img-40 img {
  width: 40px !important;
  height: 40px !important;
}

.p-125 {
  padding: 0.875rem;
}

.VSP-hover:hover {
  text-decoration: underline;
  font-size: 1rem;
}

.owl-theme .owl-nav {
  margin-top: 0px !important;
}

.chat-hover span {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hover-chat-heart span {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chat-hover span:hover,
.hover-chat-heart span:hover {
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.hover-chat-heart span:hover {
  background-color: #fff;

  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.095) !important;
}

.dropdown-seller span {
  display: flex;
  justify-content: start;
  width: 100%;
  border-radius: 4px !important;
  display: block;
}

.dropdown-seller span:hover {
  background-color: #f0f2f5 !important;
}

.comment-list:first-of-type {
  /* Apply margin to all comments except the first one */
  margin-top: 8px !important;
}

.comment-list:not(:first-of-type) {
  margin-top: 0.875rem !important;
}

@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 1280px !important;
  }
}

.footer-logo:hover {
  background-color: #ffffff !important;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.footer-logo:hover svg path {
  fill: rgb(56, 176, 0);
}

.seller-posts .seller-post {
  padding: 16px 0px 12px 0px !important;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.seller-posts .seller-post .p-125 {
  padding: 0px 16px !important;
}

.seller-posts .seller-post .p-125.post-actions-lcs {
  padding: 0.55rem 1rem !important;
}

.seller-posts .seller-post .seller-post-comment {
  padding: 0.55rem 1rem 0rem 1rem !important;
}

.seller-posts .seller-post img {
  padding: 0rem 0rem 0rem 0rem !important;
}

.dropdown-seller div {
  display: none;
  margin-top: 0rem;
  position: absolute;
  right: 0px;
  background-color: rgb(255, 255, 255);
  min-width: 10rem;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 10px;
  z-index: 2;
  border-radius: 0.5rem;
  overflow: hidden;
  padding: 8px;
}

.dropdown-seller span {
  color: rgb(0, 0, 0) !important;
  font-size: 0.875rem;
  padding: 0.425rem 0.8rem;
  text-decoration: none;
  display: block;
  border-radius: 4px;
  background-color: rgb(255, 255, 255);
  text-align: left;
  cursor: pointer;
}

.Emoji-input {
  font-size: 20rem;
}

.dots-v-hover {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.dots-v-hover:hover {
  background-color: #f0f2f5;
}

.dots-v-hover > div {
  top: 26px !important;
  padding: 8px;
}

.dots-v-hover > div span {
  color: black !important;
  border-radius: 4px;
}

.react-responsive-modal-modal {
  padding: 2.5rem 2rem !important;
}

@media (max-width: 786px) {
  .seller-post-comment {
    margin-bottom: 0px !important;
  }

  .react-responsive-modal-modal {
    padding: 1.2rem 1rem !important;
  }
}

.img-icon-gap {
  gap: 1.25rem !important;
}

@media screen and (min-width: 0px) and (max-width: 768px) {
  .react-input-emoji--input {
    padding: 12px 126px 12px 12px !important;
    font-size: 6px !important;
  }

  .react-input-emoji--button {
    /* bottom: -2.2rem; */
    padding: 0px !important;
  }

  .img-icon-gap {
    gap: 0.75rem !important;
  }
}

.social-icons a:hover {
  filter: brightness(0.5);
}

.side-img-text {
  font-size: 13px;
}

.side-img-text a {
  color: rgb(56, 176, 0);
}

.icon-text-hover:hover div {
  color: rgb(56, 176, 0);
}

.icon-text-hover:hover img {
  filter: invert(49%) sepia(36%) saturate(2429%) hue-rotate(66deg)
    brightness(96%) contrast(101%);
}

.wy-item-body {
}

.wy-appbar {
  padding: 0px !important;
}

.wy-headline {
  margin-top: 0px !important;
}

.wy-item-lg {
  padding: 0.6rem 0.75rem;
}

.wy-avatar-header {
  padding: 8px !important;
}

.wy-avatar-header .wy-avatar-presence img {
  width: 100px !important;
  height: 100px !important;
}

.wy-message {
  gap: 6px;
  margin-bottom: 2rem !important;
}

:not(tr).wy-pager {
  margin-top: 0px !important;
}

.wy-message-author {
  margin: 0px !important;
}

.wy-message-bubble {
  padding: 0.5rem !important;
  border-radius: 6px !important;
  background-color: #f8f5ff !important;
  padding-top: 0px !important;
}

.wy-message.wy-message-me .wy-message-bubble {
  background-color: #e9f3ff !important;
}

.wy-button-icon {
  width: 24px !important;
  height: 24px !important;
}

.wy-message-editor-inputs {
  align-items: center !important;
}

.wy-dropdown-menu {
  background-color: #ffffff !important;
  padding: 8px !important;
}

.wy-dropdown-menu .wy-dropdown-item {
  border-radius: 8px !important;
  padding: 0.5rem 1rem !important;
  font-size: 14px;
}

.wy-dropdown-menu .wy-dropdown-item svg {
  width: 16px;
  height: 16px;
}

.wy-dropdown-menu.wy-dropdown-menu-end {
  transform: none !important;
  top: 24px !important;
}

.wy-pane-body {
  display: block !important;
}

::-webkit-scrollbar {
  display: none;
}

.wy-like-count {
  background-color: transparent !important;
  font-size: 13px !important;
  padding: 0px !important;
}

/* .wy-button:not(.wy-button-link, :disabled)::before  {
 background-color: transparent !important;
} */

.wy-like-button::before {
  background-color: transparent !important;
}

.wy-like-button svg {
  width: 16px !important;
  height: 16px !important;
}

.wy-message-editor {
  padding: 0px 4px !important;
}

.wy-message-bubble .wy-reactions-line {
  padding-bottom: 4px;
  margin: 0px !important;
}

.wy-message-editor-inputs svg.wy-icon.wy-icon-primary {
  width: 2rem !important;
  height: 2rem !important;
}

/* .wy-message-editor-inputs svg.wy-icon.wy-icon-primary:hover::before {
	background-color: transparent !important;

} */

.wy-message-editor-inputs svg.wy-icon.wy-icon-primary path {
  fill: #0fcba1;
}

.wy-message-editor .ͼ1.cm-editor {
  background-color: #ffffff;
}

.wy-message-editor-inputs {
  gap: 6px;
}

.wy-message-editor .wy-button.wy-button-icon:hover:last-child::before {
  background: #f0f4f9 !important;
}

.StripeElement {
  margin-bottom: 1rem !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.buyer-btns {
  border: 1px solid #d0d5dd !important;
  margin: 0.3rem;
  padding: 10px 18px;
  border-radius: 2rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #344054;
  background-color: #fff !important;
}

.buyer-btns:hover,
.buyer-btns:active,
.buyer-btns.hover {
  background-color: #f9fafb !important;
}

.seller-button button {
  border: 2px solid rgb(56, 176, 0) !important;
}

.buyer-button button:last-child,
.seller-button button:first-child {
  background-color: transparent !important;
  color: #344054 !important;
  border: 2px solid rgb(56, 176, 0);
}

@media (max-width: 768px) {
  .buyer-btns {
    padding: 8px 12px;
  }
}

.payment-cards td {
  border: 1px solid rgb(238, 238, 238) !important;
}

.payment-cards td:first-child {
  font-weight: 500;
  border-top-left-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.payment-cards td:first-child,
.payment-cards td:nth-child(2) {
  border-right: 0px !important;
}

.payment-cards td:nth-child(2),
.payment-cards td:last-child {
  border-left: 0px !important;
}

.payment-cards td:last-child {
  border-top-right-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}

.payment-cards td {
  padding: 16px 12px !important;
}

.default-card.payment-cards td {
  border-color: rgb(56, 176, 0) !important;
  background-color: #e7ffee;
}

.default-card.payment-cards td:last-child {
  border-color: rgb(56, 176, 0) !important;
  background-color: #e7ffee;
}

#cb1 {
  accent-color: rgb(56 149 12);
  width: 16px;
  height: 32px;
}

#cb-checkout {
  height: 42px;
}

.Toastify__toast-body {
  align-items: start !important;
}


wy-messenger {
  --wy-theme-color: #1e3a8a;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;EAEE,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,mFAA8E;AAChF;;AAEA;EACE,yBAAyB;EACzB;8DACwD;AAC1D;;AAEA;EACE,2BAA2B;EAC3B;8DAC0D;AAC5D;;AAEA;EACE,wBAAwB;EACxB,mFAA8E;AAChF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;AACA;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAIE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,8CAA8C;EAC9C,2CAA2C;EAC3C,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA,uCAAuC;AACvC;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,sCAAsC;AACtC;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;EAIE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uCAAkC;IAAlC,kCAAkC;EACpC;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,0CAA0C;;AAE1C,uCAAuC;AACvC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2CAA2C;;AAE3C,wCAAwC;AACxC;;EAEE,sBAAsB;EACtB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;;;EAGE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;;EAEE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;;EAEE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;;;;;;;;EASE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;EAGE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;EACV,uDAAuD;AACzD;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,4CAA4C;;AAE5C,8CAA8C;AAC9C;EACE,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kDAAkD;;AAElD,iCAAiC;;AAEjC;EACE,kCAAkC;EAClC,oCAAoC;EACpC,kCAAkC;EAClC,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,qCAAqC;EACrC,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,0BAA0B;EAC1B,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,qCAAqC;;AAErC,uCAAuC;AACvC;EACE;uBACqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,0DAA0D;EAC1D,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;;EAExC,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,gEAAgE;EAChE,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,0DAA0D;EAC1D,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;EAGE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,sBAAsB;;AAEtB;EACE,yBAAyB;EACzB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,kBAAkB;;EAElB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;;;;;GAUG;;AAEH;;EAEE,kBAAkB;AACpB;;AAEA;AACA;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE;IACE,sDAAsD;EACxD;;EAEA;IACE,wDAAwD;EAC1D;AACF;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,UAAU;AACZ;;AAEA;EACE;IACE,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;GAEG;;AAEH;;;GAGG;;AAEH;;;;;;;;;GASG;;AAEH;;;GAGG;;AAEH;;;;;;GAMG;;AAEH;EACE,gCAAgC;EAChC,sBAAsB;EACtB,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;;;;;;GAMG;;AAEH;;;;;;;GAOG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,sBAAsB;;EAEtB,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sDAAsD;EACtD,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;;;;;IAKE,4BAA4B;EAC9B;AACF;;AAEA;EACE,oCAAoC;EACpC,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,gBAAgB;EAChB,2CAA2C;EAC3C,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,wCAAwC;IACxC,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;kCACgC;AAClC;;AAEA;AACA;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,wCAAwC;EACxC,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,yBAAyB;AAC3B","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Roboto\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 400 !important;\n  background-color: #f0f2f5;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nhtml {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -ms-overflow-style: scrollbar;\n  font-size: 1rem !important;\n}\n\n@font-face {\n  font-family: \"Lato-Thin\";\n  src: local(\"Lato-Thin\"), url(\"./styled/font/Lato-Thin.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Lato-Light\";\n  src: local(\"Lato-Light\"),\n    url(\"./styled/font/Lato-Light.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Lato-Regular\";\n  src: local(\"Lato-Regular\"),\n    url(\"./styled/font/Lato-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Lato-Bold\";\n  src: local(\"Lato-Bold\"), url(\"./styled/font/Lato-Bold.ttf\") format(\"truetype\");\n}\n\n.customOverlay {\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.smallModal {\n  min-width: 35rem;\n  max-width: 35rem !important;\n  border-radius: 0.875rem;\n  padding: 0 !important;\n  overflow-y: visible !important;\n}\n\n.addPost {\n  min-width: 40rem;\n  max-width: 40rem !important;\n  border-radius: 1.875rem;\n  padding: 0 !important;\n}\n\n@media screen and (min-width: 620px) and (max-width: 9999px) {\n  .addPost {\n    min-width: 35rem;\n    max-width: 35rem !important;\n  }\n}\n\n@media screen and (min-width: 520px) and (max-width: 620px) {\n  .addPost {\n    min-width: 30rem;\n    max-width: 30rem !important;\n  }\n}\n\n@media screen and (min-width: 480px) and (max-width: 520px) {\n  .addPost {\n    min-width: 25rem !important;\n    max-width: 25rem !important;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .addPost {\n    min-width: 10.125rem !important;\n    max-width: 25rem !important;\n  }\n}\n\n.imageCropModal {\n  min-width: 50rem !important;\n  min-height: 30rem !important;\n  border-radius: 0.875rem !important;\n  padding: 0 !important;\n}\n\n.addPostModal {\n  min-width: 40rem;\n  max-width: 40rem !important;\n  overflow-y: visible !important;\n  border-radius: 0.875rem !important;\n  padding: 0 !important;\n}\n\n@media screen and (min-width: 620px) and (max-width: 9999px) {\n}\n\n@media screen and (min-width: 520px) and (max-width: 620px) {\n  .addPostModal {\n    min-width: 30rem;\n    max-width: 30rem !important;\n  }\n}\n\n@media screen and (min-width: 480px) and (max-width: 520px) {\n  .addPostModal {\n    min-width: 25rem !important;\n    max-width: 25rem !important;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .addPostModal {\n    min-width: 10.125rem !important;\n    max-width: 25rem !important;\n  }\n}\n\n.successModal {\n  min-width: 35rem;\n  border-radius: 1.875rem;\n}\n\n.locationModal {\n  border-radius: 1.875rem;\n  padding: 0 !important;\n}\n\n.slider-control-bottomcenter > ul {\n  top: 1rem !important;\n}\n\n.paging-item > button {\n  padding: 0.2rem;\n}\n\n.paging-item.active > button {\n  fill: green !important;\n}\n\n@media screen and (min-width: 620px) and (max-width: 9999px) {\n  .locationModal {\n    min-width: 35rem;\n    max-width: 35rem !important;\n  }\n}\n\n@media screen and (min-width: 520px) and (max-width: 620px) {\n  .locationModal,\n  .smallModal {\n    min-width: 30rem;\n    max-width: 30rem !important;\n  }\n}\n\n@media screen and (min-width: 0px) and (max-width: 419px) {\n  .locationModal {\n    min-width: 20rem;\n    max-width: 20rem !important;\n  }\n}\n\n@media screen and (min-width: 0px) and (max-width: 520px) {\n  .smallModal {\n    min-width: 20rem;\n    max-width: 20rem !important;\n  }\n}\n\n.downLoadReportModal {\n  min-width: 32rem;\n  max-width: 32rem !important;\n  border-radius: 6px;\n  padding: 0 !important;\n}\n\n.filterModal {\n  min-width: 28rem;\n  max-width: 28rem !important;\n  border-radius: 6px;\n  padding: 0 !important;\n}\n\n.toast-container {\n  z-index: 9999999 !important;\n}\n\n.reviewRequest {\n  min-width: 32rem;\n  max-width: 32rem !important;\n  border-radius: 6px;\n  padding: 0 !important;\n}\n\n.addReviewModal {\n  min-width: 27rem;\n  max-width: 27rem !important;\n  border-radius: 6px;\n  padding: 0 !important;\n}\n\n.createNewApiModal {\n  min-width: 30rem;\n  max-width: 30rem !important;\n  border-radius: 6px;\n  padding: 0 !important;\n}\n\n.editModal {\n  min-width: 28rem;\n  max-width: 30rem !important;\n  border-radius: 6px;\n  padding: 0 !important;\n}\n\n.addNewModal {\n  min-width: 28rem;\n  max-width: 28rem !important;\n  border-radius: 6px;\n  padding: 0 !important;\n}\n\n.bulkCardModal {\n  border-radius: 6px;\n  padding: 0 !important;\n}\n\n.compaignModal {\n  max-width: 1200px !important;\n}\n\np {\n  margin-bottom: 0;\n  margin: 0 0 0px;\n}\n\n*,\n*::before,\n*::after {\n  -webkit-box-sizing: inherit;\n  box-sizing: inherit;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin: 0;\n  /* font-family: 'Playfair Display', serif; */\n}\n\n#carousel div div.carousel .thumbs-wrapper {\n  margin: 0rem !important;\n}\n\n#carousel div.carousel-root div.carousel.carousel-slider .control-dots {\n  margin-bottom: 4.5rem;\n}\n\n@media screen and (min-width: 0px) and (max-width: 767px) {\n  #carousel div.carousel-root div.carousel.carousel-slider .control-dots {\n    margin-bottom: 1rem;\n  }\n}\n\n#pre,\n#next {\n  display: none;\n}\n\n#testimonials div.carousel-root div.carousel.carousel-slider .control-dots {\n  display: none;\n}\n\n#testimonialsPre,\n#testimonialsNext {\n  display: none;\n}\n\n.phoneInputFields {\n  font-family: \"Roboto\";\n  width: 100% !important;\n  line-height: 2rem !important;\n  outline: none;\n  font-weight: 400;\n  text-align: left;\n  font-size: 0.875rem !important;\n  border-radius: 0.375rem !important;\n  padding: 0.5rem 0.8rem !important;\n  padding-left: 60px !important;\n  border: 1px solid #e1e1e1 !important;\n  color: #333333;\n  background: #ffffff;\n  height: auto !important;\n}\n\n.react-tel-input .flag-dropdown {\n  top: 0.063rem !important;\n  bottom: 0.063rem !important;\n  left: 0.063rem !important;\n  width: 3rem !important;\n  background: #ffffff00 !important;\n  border-bottom-left-radius: 0.375rem !important;\n  border-top-left-radius: 0.375rem !important;\n  border-top: none !important;\n  border-bottom: none !important;\n  border-left: none !important;\n  border-right: 1px solid #e1e1e1 !important;\n  padding-left: 0.2rem !important;\n}\n\n.phoneInputFields:focus {\n  border: 1px solid #1fc3e0 !important;\n  box-shadow: none !important;\n}\n\n.phoneInputFields:focus + .flag-dropdown {\n  border-right: 1px solid #1fc3e0 !important;\n  box-shadow: none !important;\n}\n\n.react-tel-input .form-control,\n.react-tel-input .selected-flag:hover,\n.react-tel-input .selected-flag:focus,\n.react-tel-input .flag-dropdown.open .selected-flag {\n  background: #ffffff00 !important;\n}\n\n/* ......... Data Table Css ......... */\ntable {\n  border-collapse: separate !important;\n  border-spacing: 0 5px !important;\n}\n\n.mdb-dataTable-head tr th {\n  font-family: \"Roboto\";\n  font-weight: 500 !important;\n  font-size: 16px !important;\n  line-height: 5px;\n  text-transform: capitalize;\n  color: #000000;\n  opacity: 0.4;\n  padding-bottom: 1.2rem !important;\n  line-height: 1;\n}\n\n.mdb-dataTable tbody tr td {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400 !important;\n  font-size: 14px;\n  line-height: 32px;\n  text-transform: capitalize;\n  color: #666666;\n}\n\ntr th:last-child {\n  text-align: end;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #ffffff8c !important;\n  border-radius: 4px;\n}\n\n.table-striped tbody tr:nth-of-type(even) {\n  background-color: white;\n  border-radius: 4px;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  color: #666666 !important;\n}\n\n.mdb-datatable table tr {\n  border-bottom: 0 !important;\n}\n\ntr td:first-child {\n  border-top-left-radius: 4px !important;\n  border-bottom-left-radius: 4px !important;\n}\n\ntr td:last-child {\n  border-top-right-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n  text-align: end;\n}\n\n.table > thead > tr > th {\n  vertical-align: bottom;\n  border-bottom: none !important;\n}\n\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n  border-top: none !important;\n  padding: 1rem 0.75rem 1.1rem 0.75rem !important;\n}\n\na:hover,\na:focus {\n  text-decoration: none !important;\n}\n\n.form-control {\n  box-shadow: none !important;\n  /* padding: 0.5rem 0.8rem !important; */\n}\n\n/* ---------- ImageCarousel  ------- */\n.image-gallery-thumbnails-container {\n  text-align: start !important;\n  padding: 0.15rem 0.5rem !important;\n}\n\n.image-gallery-thumbnails-container button {\n  border: none !important;\n  margin-right: 0.43rem;\n}\n\n.image-gallery-thumbnails-container button > span > img {\n  border-radius: 4px !important;\n  opacity: 0.5;\n  object-fit: cover;\n}\n\n.image-gallery-thumbnails-container button > span > img {\n  border-radius: 4px !important;\n  opacity: 0.5;\n  height: 5.7rem;\n}\n\n.image-gallery-thumbnails-container\n  button.image-gallery-thumbnail.active\n  > span\n  > img {\n  border-radius: 4px !important;\n  opacity: 1 !important;\n}\n\n.image-gallery-image {\n  object-fit: cover !important;\n}\n\n@media screen and (min-width: 992px) and (max-width: 9999px) {\n  .image-gallery-image {\n    height: 24.5rem;\n  }\n}\n\n@media screen and (min-width: 0px) and (max-width: 992px) {\n  .image-gallery-image {\n    max-height: fit-content !important;\n  }\n\n  .image-gallery-thumbnails-container button > span > img {\n    height: 4.7rem;\n  }\n}\n\n/* ---------- ImageCarousel End  ------- */\n\n/* ----------  AdminGraph ----------  */\n.recharts-text {\n  font-family: \"Roboto\";\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 24px;\n  padding: 0.5rem;\n}\n\n/* ----------  AdminGraph End ----------  */\n\n/* --------SummerNote Fixing---------- */\n.btn-default,\n.btn-default.dropdown-toggle {\n  color: #333 !important;\n  background-color: #fff !important;\n  border-color: #ccc !important;\n}\n\n.btn-sm,\n.btn-group-sm > .btn {\n  padding: 5px 10px !important;\n  font-size: 12px !important;\n  line-height: 1.5 !important;\n  border-radius: 3px !important;\n}\n\n.btn {\n  margin: 0 !important;\n  text-transform: capitalize !important;\n}\n\n.btn:hover,\n.btn:focus,\n.btn:active {\n  outline: 0 !important;\n  box-shadow: none !important;\n}\n\n.btn-group,\n.btn-group-vertical {\n  box-shadow: none !important;\n}\n\n.btn-group > .btn:first-child {\n  margin-left: 0 !important;\n}\n\n.btn-default.dropdown-toggle:hover,\n.btn-default.dropdown-toggle:focus {\n  color: #333 !important;\n  background-color: #e6e6e6 !important;\n  border-color: #adadad !important;\n}\n\n.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.btn-group > .btn-group:not(:last-child) > .btn,\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0 !important;\n}\n\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group {\n  margin-left: -1px !important;\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.note-popover .popover-content .note-color .dropdown-toggle,\n.note-editor .note-toolbar .note-color .dropdown-toggle {\n  padding-left: 5px !important;\n}\n\n.btn-default:active:hover,\n.btn-default.active:hover,\n.open > .dropdown-toggle.btn-default:hover,\n.btn-default:active:focus,\n.btn-default.active:focus,\n.open > .dropdown-toggle.btn-default:focus,\n.btn-default:active.focus,\n.btn-default.active.focus,\n.open > .dropdown-toggle.btn-default.focus {\n  color: #333 !important;\n  background-color: #d4d4d4 !important;\n  border-color: #8c8c8c !important;\n}\n\n.btn-default:not([disabled]):not(.disabled):active,\n.btn-default:not([disabled]):not(.disabled).active,\n.show > .btn-default.dropdown-toggle {\n  background-color: #d4d4d4 !important;\n  box-shadow: none;\n}\n\n.btn:active,\n.btn.active {\n  background-image: none;\n  outline: 0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%) !important;\n}\n\n.btn-default:active,\n.btn-default.active,\n.open > .dropdown-toggle.btn-default {\n  color: #333 !important;\n  background-color: #e6e6e6 !important;\n  background-image: none;\n  border-color: #adadad !important;\n}\n\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group {\n  margin-left: -1px !important;\n}\n\n.btn-default:hover {\n  color: #333 !important;\n  background-color: #e6e6e6 !important;\n  border-color: #adadad !important;\n}\n\n/* --------SummerNote Fixing End---------- */\n\n/* --------SummerNote Model Fixing---------- */\nbutton.close {\n  padding: 0 !important;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  appearance: none;\n}\n\n.modal-header {\n  display: block !important;\n}\n\n.modal-header .close {\n  margin: auto !important;\n}\n\n.note-group-select-from-files input {\n  font: -webkit-control !important;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7 !important;\n  border-color: #2e6da4 !important;\n}\n\n.btn[disabled] {\n  cursor: not-allowed !important;\n}\n\n.note-editable {\n  background-color: transparent !important;\n}\n\n/* --------SummerNote Model Fixing End---------- */\n\n/* --------Input Tags---------- */\n\n.rti--container {\n  background: transparent !important;\n  border: 1px solid #e1e1e1 !important;\n  border-radius: 0.375rem !important;\n  line-height: 2rem !important;\n  padding: 0.5rem 0.8rem !important;\n  font-size: 0.875rem !important;\n}\n\n.rti--container > input {\n  padding: 0 !important;\n}\n\n.rti--container:focus-within {\n  border-color: #1fc3e0 !important;\n  box-shadow: none !important;\n}\n\n.rti--tag {\n  background: #56ccf2 !important;\n  border-radius: 6px !important;\n  padding: 0 0.2rem 0 0.7rem !important;\n  color: #ffffff !important;\n  font-family: \"Roboto\" !important;\n  font-weight: 400 !important;\n  font-size: 14px !important;\n  justify-content: space-between !important;\n  text-transform: capitalize !important;\n}\n\n.rti--tag > span {\n  padding-right: 0.5rem !important;\n}\n\n.rti--tag > button {\n  font-size: 0.7rem !important;\n  font-weight: 700 !important;\n}\n\n/* --------Input Tags End---------- */\n\n/* --------- POST CARUSEL ----------- */\n.owl-nav {\n  /* display: flex;\n\talign-items: center; */\n  /* display: none; */\n}\n\n.owl-prev {\n  /* display: none !important; */\n  position: absolute !important;\n  left: 0rem !important;\n  top: 40% !important;\n  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5) !important;\n  position: absolute !important;\n  background: white !important;\n  width: 2rem !important;\n  border-radius: 100% !important;\n  height: 2rem !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.owl-prev:hover {\n  /* background: transparent !important; */\n  background: rgb(56, 176, 0) !important;\n}\n\n.owl-next:hover {\n  /* background: transparent !important; */\n\n  background: rgb(56, 176, 0) !important;\n}\n\n.owl-next {\n  /* display: none !important; */\n  /* box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5) !important; */\n  position: absolute !important;\n  right: 0rem !important;\n  top: 40% !important;\n  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5) !important;\n  position: absolute !important;\n  background: white !important;\n  width: 2rem !important;\n  border-radius: 100% !important;\n  height: 2rem !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.owl-next span {\n  color: black !important;\n  font-size: 26px;\n  display: block;\n  top: -5px;\n  position: absolute;\n}\n\n.owl-prev span {\n  color: black !important;\n  font-size: 26px;\n  display: block;\n  top: -5px;\n  position: absolute;\n}\n\n.owl-next:hover span,\n.owl-prev:hover span {\n  color: #ffffff !important;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n  border: 0.25em solid #ffffff !important;\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-line\"],\n.swal2-icon.swal2-success [class^=\"swal2-success-line\"] {\n  background-color: #ffffff !important;\n}\n\n.swal2-popup {\n  background: #0e7b2f !important;\n  color: #ffffff !important;\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-circular-line\"][class$=\"left\"],\n.swal2-icon.swal2-success .swal2-success-fix,\n.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right {\n  background-color: rgb(62 21 21 / 0%) !important;\n}\n\n.swal2-styled.swal2-confirm {\n  background-color: #ffffff !important;\n  color: #0e7b2f !important;\n  padding: 0.5rem 2rem !important;\n  border: none !important;\n  outline: none !important;\n}\n\n/* REACT DATEPICKER/ */\n\n.react-calendar__navigation__label {\n  color: #40730a !important;\n  /* font-weight: 700 !important; */\n  /* font-size: 1.5rem; */\n}\n\n.react-calendar__month-view__weekdays__weekday {\n  text-decoration: underline !important;\n}\n\n.react-calendar__tile--active {\n  background-color: #32cd32 !important;\n}\n\n.react-calendar__navigation > button {\n  color: #32cd32 !important;\n}\n\n.react-calendar__tile:enabled:hover {\n  background-color: #ff7d09 !important;\n}\n\n.react-calendar__navigation button:enabled:hover {\n  background-color: #ff7d09 !important;\n  color: white !important;\n}\n\n.react-calendar__tile--now {\n  background-color: #32cd32 !important;\n}\n\n.react-datetime-picker__wrapper {\n  border: none !important;\n  display: flex !important;\n}\n\n.character {\n  display: flex;\n  justify-content: center !important;\n  align-items: center !important;\n  border: none;\n  font-size: 20px;\n  border-radius: 8px;\n\n  /* light theme */\n  color: #272729;\n  background-color: #f6f5fa;\n  box-shadow: 0 2px 0 #e4e2f5;\n}\n\n.upload {\n  margin: 0;\n}\n\n.rmsc {\n  --rmsc-main: #4285f4 !important;\n  --rmsc-hover: #3f730a !important;\n  --rmsc-selected: #e2e6ea;\n  --rmsc-border: #ccc;\n  --rmsc-gray: #aaa;\n  --rmsc-bg: #fff;\n  /* color: #fff; */\n  --rmsc-p: 10px;\n  /* Spacing */\n  --rmsc-radius: 4px;\n  /* Radius */\n  --rmsc-h: 38px;\n  /* Height */\n}\n\n/* .e-multiselect.e-input-group .e-input-group-icon,\n.e-multiselect.e-input-group.e-control-wrapper .e-input-group-icon:hover {\n\tcolor: red !important;\n\tfont-size: 14px;\n}\n\n.e-popup .e-checkbox-wrapper .e-frame.e-check,\n.e-popup .e-checkbox-wrapper:hover .e-frame.e-check {\n\tbackground-color: green !important;\n\tcolor: white;\n} */\n\nol,\nul {\n  padding-left: 0rem;\n}\n\n.rmsc .select input:focus {\n}\n\n.dropdown-container {\n  /* background: red !important; */\n  border: 1px solid #efeff0 !important;\n}\n\n.select-item {\n  margin: 0px !important;\n  /* color: white !important; */\n}\n\n.select-item:hover {\n  margin: 0px !important;\n  color: white !important;\n}\n\n.paging-item {\n  display: none !important;\n}\n\n/* //Spinner 1  */\n\n.spinner-container {\n  position: relative;\n  width: 100px;\n  height: 100px;\n}\n\n.spinner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 5px solid #0fcba1;\n  border-top-color: #fff;\n  animation: spin 1s infinite linear;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotateX(35deg) rotateY(45deg) rotateZ(0deg);\n  }\n\n  100% {\n    transform: rotateX(35deg) rotateY(45deg) rotateZ(360deg);\n  }\n}\n\n/* Chrome, Safari, Edge, Opera */\n#quantity input::-webkit-outer-spin-button,\n#quantity input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n#quantity input[type=\"number\"] {\n  -moz-appearance: textfield;\n  /* text-align: center; */\n}\n\n.dropdown-content {\n  z-index: 2 !important;\n}\n\n.react-input-emoji--container {\n  background-color: #ffffff !important;\n  border: 1px solid #ffffff !important;\n  border-radius: 30px !important;\n}\n\n.react-input-emoji--input {\n  min-height: 40px !important;\n  height: auto;\n  padding: 10px 165px 10px 20px !important;\n  background-color: #f0f2f5;\n  border-radius: 1.5rem;\n  vertical-align: middle;\n  word-break: break-all;\n}\n\n.react-input-emoji--button svg {\n  fill: #6c757d !important;\n  width: 20px;\n  height: 20px;\n}\n\n.react-input-emoji--button__show svg {\n  fill: #32cd32 !important;\n}\n\n.react-input-emoji--button {\n  position: absolute !important;\n  right: 5.2rem;\n  z-index: 2;\n}\n\n@media screen and (min-width: 0px) and (max-width: 768px) {\n  .react-input-emoji--input {\n    padding: 12px 126px 12px 12px !important;\n    font-size: 12px !important;\n  }\n\n  .react-input-emoji--button {\n    /* bottom: -2.2rem; */\n    padding: 0px !important;\n  }\n}\n\n.react-emoji-picker--wrapper {\n  z-index: 1 !important;\n}\n\n.react-input-emoji--container {\n  margin: 0 !important;\n}\n\n#customCalendar .react-datetime-picker__inputGroup {\n  display: none !important;\n}\n.react-datetime-picker__inputGroup {\n  margin-right: 10px !important;\n}\n\n.react-datetime-picker__inputGroup__leadingZero {\n  display: none !important;\n}\n\n.react-datetime-picker__calendar {\n  z-index: 2 !important;\n}\n\n/* .wy-avatar-presence img {\n  object-fit: cover;\n} */\n\n/* .wy-avatar-presence.wy-avatar {\n\theight: rem;\n\twidth: 6rem;\n} */\n\n/* .wy-appbars {\n  z-index: 0 !important;\n  box-shadow: none !important;\n  border-bottom: 1px solid rgb(221 221 234);\n  background-color: #ffffff !important;\n  backdrop-filter: none;\n  padding: 8px;\n  border-radius: 12px 12px 0px 0px;\n  position: static !important;\n} */\n\n/* .wy-appbar {\n  z-index: 0 !important;\n  font-weight: 600;\n} */\n\n/* .wy-messages {\n   max-height: 33rem;  \n  max-height: calc(100vh - 270px);\n  overflow: hidden;\n  overflow-y: scroll;\n  height: 100vh;\n} */\n\n.wy-messages {\n  border: 2px solid red !important;\n  /* overflow: scroll; */\n  /* min-height: calc(100vh - 220px); */\n  /* max-height: calc(100vh - 220px); */\n}\n\n/* .wy-conversations {\n  max-height: 80vh;\n  position: relative;\n  overflow-y: auto;\n  width: 25rem;\n  padding: 0.875rem;\n} */\n\n/* @media screen and (min-width: 0px) and (max-width: 767px) {\n  .wy-conversations {\n    max-height: 33rem;\n    position: relative;\n    overflow-y: scroll;\n    width: 100%;\n  }\n} */\n\n.wy-meta {\n  font-size: 12px !important;\n}\n\n.wy-item-text {\n  font-size: 14px !important;\n}\n\n.wy-item-hover {\n  border-radius: 12px;\n}\n\n.wy-item-hover:hover {\n  background-color: #eef2f6;\n  border-radius: 12px;\n}\n\n.react-datetime-picker__button {\n  padding: 0rem !important;\n}\n\n.react-datetime-picker__inputGroup__input {\n  padding: 0px 1px !important;\n  height: auto !important;\n  width: 60px !important;\n  text-align: center !important;\n}\n\n.hide-month-icon .react-date-picker__button__icon {\n  display: none;\n}\n\n.connectModel {\n  /* width: 100%; */\n  padding: 50px !important;\n  border-radius: 0.875rem;\n  background: #fff;\n}\n\n.productDetailModel {\n  padding: 50px !important;\n  border-radius: 0.875rem;\n  background: #fff;\n  width: 100%;\n}\n\n.commentModel {\n  border-radius: 0.875rem;\n  background: #fff;\n  width: 100%;\n}\n\n@media screen and (min-width: 0px) and (max-width: 840px) {\n  .productDetailModel {\n    width: 90%;\n  }\n\n  .commentModel {\n    width: 90%;\n    padding: 0 !important;\n  }\n}\n\n.react-datetime-picker__inputGroup__input--hasLeadingZero {\n  margin-left: -0.014em !important;\n}\n\n.reactEasyCrop_CropArea.reactEasyCrop_CropAreaGrid {\n  width: 450px !important;\n  height: 250px !important;\n}\n\n/* .owl-item {\n\tmargin-right: 0px !important;\n} */\n\n.owl-item img {\n  border-radius: 0.5rem !important;\n}\n\n#postsCarosel .owl-item {\n  display: flex;\n  justify-content: center;\n}\n\n#postsCarosel .owl-carousel .owl-stage {\n  display: flex;\n  align-items: center;\n}\n\n#postsCarosel .owl-carousel .owl-item img {\n  width: auto;\n  height: 100%;\n  object-fit: cover;\n  aspect-ratio: 16/9;\n  border-radius: 0rem !important;\n}\n\n#postsCarosel .owl-carousel .owl-item {\n  margin-right: 0px !important;\n}\n\n.swal2-popup {\n  background-color: rgb(223, 222, 222) !important;\n}\n\n.my-custom-swal .swal2-close {\n  color: black;\n}\n\n#postsCarosel .owl-carousel .owl-item img {\n  width: 100% !important;\n}\n\n.owl-theme .owl-nav {\n  margin-top: 0px;\n}\n\n.hover-link {\n  border-bottom: 2px solid transparent;\n}\n\n.hover-link:hover {\n  /* border-bottom: 2px solid rgb(56, 176, 0); */\n  border-color: rgb(56, 176, 0);\n}\n\n.width-100 {\n  width: 33.33%;\n  background-color: #0e7b2f;\n}\n\n.post-actions-lcs a {\n  border-radius: 6px;\n  padding: 8px !important;\n}\n\n.post-actions-lcs a:hover {\n  background-color: #f2f2f2;\n}\n\n.most-viewed-posts {\n  padding: 0px;\n  border-radius: 48px;\n  margin-bottom: 8px;\n}\n\n.most-viewed-posts:hover {\n  background-color: #e7e7e8;\n}\n\n.dots-hover {\n  padding: 8px;\n}\n\n.dots-hover:hover {\n  background-color: #f0f2f5;\n  border-radius: 50%;\n}\n\n.w-14px {\n  width: 14px !important;\n}\n\n/* .most-viewed {\n\tbackground-color: #F7F9F9 !important;\n\tborder-radius: 12px;\n} */\n\n.img-40 img {\n  width: 40px !important;\n  height: 40px !important;\n}\n\n.p-125 {\n  padding: 0.875rem;\n}\n\n.VSP-hover:hover {\n  text-decoration: underline;\n  font-size: 1rem;\n}\n\n.owl-theme .owl-nav {\n  margin-top: 0px !important;\n}\n\n.chat-hover span {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.hover-chat-heart span {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.chat-hover span:hover,\n.hover-chat-heart span:hover {\n  background-color: #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.hover-chat-heart span:hover {\n  background-color: #fff;\n\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.095) !important;\n}\n\n.dropdown-seller span {\n  display: flex;\n  justify-content: start;\n  width: 100%;\n  border-radius: 4px !important;\n  display: block;\n}\n\n.dropdown-seller span:hover {\n  background-color: #f0f2f5 !important;\n}\n\n.comment-list:first-of-type {\n  /* Apply margin to all comments except the first one */\n  margin-top: 8px !important;\n}\n\n.comment-list:not(:first-of-type) {\n  margin-top: 0.875rem !important;\n}\n\n@media (min-width: 1200px) {\n  .container,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container-xl {\n    max-width: 1280px !important;\n  }\n}\n\n.footer-logo:hover {\n  background-color: #ffffff !important;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.footer-logo:hover svg path {\n  fill: rgb(56, 176, 0);\n}\n\n.seller-posts .seller-post {\n  padding: 16px 0px 12px 0px !important;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.seller-posts .seller-post .p-125 {\n  padding: 0px 16px !important;\n}\n\n.seller-posts .seller-post .p-125.post-actions-lcs {\n  padding: 0.55rem 1rem !important;\n}\n\n.seller-posts .seller-post .seller-post-comment {\n  padding: 0.55rem 1rem 0rem 1rem !important;\n}\n\n.seller-posts .seller-post img {\n  padding: 0rem 0rem 0rem 0rem !important;\n}\n\n.dropdown-seller div {\n  display: none;\n  margin-top: 0rem;\n  position: absolute;\n  right: 0px;\n  background-color: rgb(255, 255, 255);\n  min-width: 10rem;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 10px;\n  z-index: 2;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  padding: 8px;\n}\n\n.dropdown-seller span {\n  color: rgb(0, 0, 0) !important;\n  font-size: 0.875rem;\n  padding: 0.425rem 0.8rem;\n  text-decoration: none;\n  display: block;\n  border-radius: 4px;\n  background-color: rgb(255, 255, 255);\n  text-align: left;\n  cursor: pointer;\n}\n\n.Emoji-input {\n  font-size: 20rem;\n}\n\n.dots-v-hover {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.dots-v-hover:hover {\n  background-color: #f0f2f5;\n}\n\n.dots-v-hover > div {\n  top: 26px !important;\n  padding: 8px;\n}\n\n.dots-v-hover > div span {\n  color: black !important;\n  border-radius: 4px;\n}\n\n.react-responsive-modal-modal {\n  padding: 2.5rem 2rem !important;\n}\n\n@media (max-width: 786px) {\n  .seller-post-comment {\n    margin-bottom: 0px !important;\n  }\n\n  .react-responsive-modal-modal {\n    padding: 1.2rem 1rem !important;\n  }\n}\n\n.img-icon-gap {\n  gap: 1.25rem !important;\n}\n\n@media screen and (min-width: 0px) and (max-width: 768px) {\n  .react-input-emoji--input {\n    padding: 12px 126px 12px 12px !important;\n    font-size: 6px !important;\n  }\n\n  .react-input-emoji--button {\n    /* bottom: -2.2rem; */\n    padding: 0px !important;\n  }\n\n  .img-icon-gap {\n    gap: 0.75rem !important;\n  }\n}\n\n.social-icons a:hover {\n  filter: brightness(0.5);\n}\n\n.side-img-text {\n  font-size: 13px;\n}\n\n.side-img-text a {\n  color: rgb(56, 176, 0);\n}\n\n.icon-text-hover:hover div {\n  color: rgb(56, 176, 0);\n}\n\n.icon-text-hover:hover img {\n  filter: invert(49%) sepia(36%) saturate(2429%) hue-rotate(66deg)\n    brightness(96%) contrast(101%);\n}\n\n.wy-item-body {\n}\n\n.wy-appbar {\n  padding: 0px !important;\n}\n\n.wy-headline {\n  margin-top: 0px !important;\n}\n\n.wy-item-lg {\n  padding: 0.6rem 0.75rem;\n}\n\n.wy-avatar-header {\n  padding: 8px !important;\n}\n\n.wy-avatar-header .wy-avatar-presence img {\n  width: 100px !important;\n  height: 100px !important;\n}\n\n.wy-message {\n  gap: 6px;\n  margin-bottom: 2rem !important;\n}\n\n:not(tr).wy-pager {\n  margin-top: 0px !important;\n}\n\n.wy-message-author {\n  margin: 0px !important;\n}\n\n.wy-message-bubble {\n  padding: 0.5rem !important;\n  border-radius: 6px !important;\n  background-color: #f8f5ff !important;\n  padding-top: 0px !important;\n}\n\n.wy-message.wy-message-me .wy-message-bubble {\n  background-color: #e9f3ff !important;\n}\n\n.wy-button-icon {\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.wy-message-editor-inputs {\n  align-items: center !important;\n}\n\n.wy-dropdown-menu {\n  background-color: #ffffff !important;\n  padding: 8px !important;\n}\n\n.wy-dropdown-menu .wy-dropdown-item {\n  border-radius: 8px !important;\n  padding: 0.5rem 1rem !important;\n  font-size: 14px;\n}\n\n.wy-dropdown-menu .wy-dropdown-item svg {\n  width: 16px;\n  height: 16px;\n}\n\n.wy-dropdown-menu.wy-dropdown-menu-end {\n  transform: none !important;\n  top: 24px !important;\n}\n\n.wy-pane-body {\n  display: block !important;\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n\n.wy-like-count {\n  background-color: transparent !important;\n  font-size: 13px !important;\n  padding: 0px !important;\n}\n\n/* .wy-button:not(.wy-button-link, :disabled)::before  {\n background-color: transparent !important;\n} */\n\n.wy-like-button::before {\n  background-color: transparent !important;\n}\n\n.wy-like-button svg {\n  width: 16px !important;\n  height: 16px !important;\n}\n\n.wy-message-editor {\n  padding: 0px 4px !important;\n}\n\n.wy-message-bubble .wy-reactions-line {\n  padding-bottom: 4px;\n  margin: 0px !important;\n}\n\n.wy-message-editor-inputs svg.wy-icon.wy-icon-primary {\n  width: 2rem !important;\n  height: 2rem !important;\n}\n\n/* .wy-message-editor-inputs svg.wy-icon.wy-icon-primary:hover::before {\n\tbackground-color: transparent !important;\n\n} */\n\n.wy-message-editor-inputs svg.wy-icon.wy-icon-primary path {\n  fill: #0fcba1;\n}\n\n.wy-message-editor .ͼ1.cm-editor {\n  background-color: #ffffff;\n}\n\n.wy-message-editor-inputs {\n  gap: 6px;\n}\n\n.wy-message-editor .wy-button.wy-button-icon:hover:last-child::before {\n  background: #f0f4f9 !important;\n}\n\n.StripeElement {\n  margin-bottom: 1rem !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.buyer-btns {\n  border: 1px solid #d0d5dd !important;\n  margin: 0.3rem;\n  padding: 10px 18px;\n  border-radius: 2rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #344054;\n  background-color: #fff !important;\n}\n\n.buyer-btns:hover,\n.buyer-btns:active,\n.buyer-btns.hover {\n  background-color: #f9fafb !important;\n}\n\n.seller-button button {\n  border: 2px solid rgb(56, 176, 0) !important;\n}\n\n.buyer-button button:last-child,\n.seller-button button:first-child {\n  background-color: transparent !important;\n  color: #344054 !important;\n  border: 2px solid rgb(56, 176, 0);\n}\n\n@media (max-width: 768px) {\n  .buyer-btns {\n    padding: 8px 12px;\n  }\n}\n\n.payment-cards td {\n  border: 1px solid rgb(238, 238, 238) !important;\n}\n\n.payment-cards td:first-child {\n  font-weight: 500;\n  border-top-left-radius: 12px !important;\n  border-bottom-left-radius: 12px !important;\n}\n\n.payment-cards td:first-child,\n.payment-cards td:nth-child(2) {\n  border-right: 0px !important;\n}\n\n.payment-cards td:nth-child(2),\n.payment-cards td:last-child {\n  border-left: 0px !important;\n}\n\n.payment-cards td:last-child {\n  border-top-right-radius: 12px !important;\n  border-bottom-right-radius: 12px !important;\n}\n\n.payment-cards td {\n  padding: 16px 12px !important;\n}\n\n.default-card.payment-cards td {\n  border-color: rgb(56, 176, 0) !important;\n  background-color: #e7ffee;\n}\n\n.default-card.payment-cards td:last-child {\n  border-color: rgb(56, 176, 0) !important;\n  background-color: #e7ffee;\n}\n\n#cb1 {\n  accent-color: rgb(56 149 12);\n  width: 16px;\n  height: 32px;\n}\n\n#cb-checkout {\n  height: 42px;\n}\n\n.Toastify__toast-body {\n  align-items: start !important;\n}\n\n\nwy-messenger {\n  --wy-theme-color: #1e3a8a;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
